import React from "react"
import { handleMenuLinkClick } from "../../../handlers"
import { Link as GatsbyLink } from "gatsby"
import { Link } from "@chakra-ui/react"

export default function DesktopItem({ url, label, style }) {
  return (
    <Link
      onClick={event => handleMenuLinkClick(url, event)}
      as={GatsbyLink}
      {...style}
      to={url}
    >
      {label}
    </Link>
  )
}
